<template>
  <v-container-principal>
    <template #header>
      <v-cabecalho nomePagina="Reservas">
        <v-cabecalho-btn
          pathTo="criarReserva"
          icone="mdi-plus"
          descricao="Nova reserva">
        </v-cabecalho-btn>
      </v-cabecalho>
    </template>

    <div>
      <v-card class="rounded-lg">
        <v-tabs v-model="tab" background-color="#EDEDED" centered>
          <v-tab
            @click="getReservas('Pendente')"
            class="text-capitalize text-lg-h6 text-md-body-1 text-sm-body-2 font-weight-bold d-flex align-end pb-2"
            >Reservas pendentes</v-tab
          >
          <v-tab
            @click="getReservas('Confirmado')"
            class="text-capitalize text-lg-h6 text-md-body-1 text-sm-body-2 font-weight-bold d-flex align-end pb-2"
            >Reservas confirmadas</v-tab
          >
          <v-tab
            @click="getReservas('Indeferida')"
            class="text-capitalize text-lg-h6 text-md-body-1 text-sm-body-2 font-weight-bold d-flex align-end pb-2"
            >Indeferidas</v-tab
          >
          <v-tab
            @click="getReservas('Historico')"
            class="text-capitalize text-lg-h6 text-md-body-1 text-sm-body-2 font-weight-bold d-flex align-end pb-2"
            >Histórico</v-tab
          >
        </v-tabs>
        <v-data-table
          class="pt-5"
          :headers="headers"
          :items="reservasComputadas"
          single-expand
          :expanded.sync="expanded"
          show-expand
          :server-items-length="footerProps.pagination.itemsLength"
          :items-per-page="footerProps.pagination.itemsPerPage"
          :footer-props="footerProps"
          :options.sync="options"
          :loading="carregando"
          loading-text="Carregando... Aguarde"
          @update:sort-desc="updateSortDesc"
          @update:page="updatePage"
          @update:items-per-page="updateItemsPerPage">
          <template v-slot:header.attributes.status="{ header }">
            {{ header.text.toUpperCase() }}
            <v-select
              class="float-start"
              v-model="filtros.estado"
              :items="estados"
              :value="estados"
              placeholder="Status"
              clearable
              v-if="selected == 'Historico'"
              @click="(event) => event.stopPropagation()">
            </v-select>
            <v-text-field
              v-else
              class="float-start"
              disabled
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template v-slot:header.attributes.publishedAt="{ header }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              v-model="filtroSolicitacao"
              placeholder="DD/MM/AAAA"
              clearable
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template v-slot:header.attributes.titulo="{ header }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              v-model="filtros.titulo"
              placeholder="Nome"
              clearable
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template
            v-slot:header.attributes.responsavel.data.attributes.username="{
              header,
            }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              v-model="filtros.responsavel"
              placeholder="Responsável"
              :clearable="isAdministrador"
              :readonly="!isAdministrador"
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template
            v-slot:header.attributes.sala.data.attributes.nome="{ header }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              disabled
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template
            v-slot:header.attributes.sala.data.attributes.bloco.descricao="{
              header,
            }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              disabled
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template v-slot:header.attributes.data_inicio="{ header }">
            {{ header.text.toUpperCase() }}
            <v-text-field
              class="float-start"
              v-model="filtroInicio"
              placeholder="DD/MM/AAAA"
              clearable
              @click="(event) => event.stopPropagation()">
            </v-text-field>
          </template>
          <template v-slot:item.attributes.status="{ item }">
            <v-icon :class="item.attributes.status.toLowerCase()"
              >mdi-circle</v-icon
            ><br />
          </template>
          <template v-slot:item.attributes.publishedAt="{ item }">
            {{ item.attributes.publishedAt | formatarData }}
          </template>
          <template
            v-slot:item.attributes.responsavel.data.attributes.username="{
              item,
            }">
            {{
              item.attributes.responsavel.data.attributes.username
                | formatarNome
            }}
            <v-tooltip v-model="item.showTooltip" right>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  icon
                  x-small
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    copiaEmail(
                      item.attributes.responsavel.data.attributes.email,
                      item.id,
                      false
                    )
                  ">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>{{ msgTooltip }}</span>
            </v-tooltip>
          </template>
          <template
            v-slot:item.attributes.sala.data.attributes.bloco.descricao="{
              item,
            }">
            {{
              item.attributes.sala.data.attributes.bloco.data.attributes
                .descricao
            }}
            - {{ item.attributes.sala.data.attributes.andar }}º Piso
          </template>
          <template v-slot:item.attributes.data_inicio="{ item }">
            <v-icon color="grey" class="mr-1">
              mdi-calendar-blank-outline
            </v-icon>
            <span class="mr-3"
              >{{ item.attributes.data_inicio | formatarData }} -
              {{ item.attributes.data_termino | formatarData }}</span
            >
            <v-icon color="grey" class="mr-1">
              mdi-clock-time-three-outline
            </v-icon>
            <span class="mr-3"
              >{{ item.attributes.horario_inicio | removerSegundos }} -
              {{ item.attributes.horario_termino | removerSegundos }}</span
            >
            <v-icon
              v-if="
                item.attributes.dias.length > 1 ||
                item.attributes.data_inicio != item.attributes.data_termino
              "
              color="grey">
              mdi-repeat
            </v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              style="background-color: #ededed"
              class="px-3 px-md-12 py-3">
              <v-row class="mb-0">
                <v-col cols="12" md="4" class="hidden-xs-only">
                  <p>
                    <strong>Solicitante:</strong><br />
                    <v-icon>mdi-account-circle</v-icon>
                    {{ item.attributes.responsavel.data.attributes.username }}
                  </p>

                  <p>
                    <strong>E-mail do solicitante:</strong><br />
                    {{ item.attributes.responsavel.data.attributes.email }}
                    <v-tooltip v-model="item.showTooltipExpandido" right>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            copiaEmail(
                              item.attributes.responsavel.data.attributes.email,
                              item.id,
                              true
                            )
                          ">
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ msgTooltip }}</span>
                    </v-tooltip>
                  </p>

                  <p>
                    <strong>Data da solicitação:</strong><br />
                    {{ item.attributes.publishedAt | formatarData }} às
                    {{ item.attributes.publishedAt | formatarHora }}
                  </p>
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <p class="hidden-xs-oly">
                    <strong>Período:</strong><br />
                    {{ item.attributes.data_inicio | formatarData }} até
                    {{ item.attributes.data_termino | formatarData }}
                  </p>
                  <p>
                    <strong>Dias da semana:</strong><br />
                    <span
                      v-for="(i, index) in item.attributes.dias"
                      :key="index"
                      >{{ i.dia.substring(0, 3) }}
                    </span>
                  </p>
                  <p class="hidden-xs-only">
                    <strong>Horário:</strong><br />
                    {{ item.attributes.horario_inicio | removerSegundos }}
                    até
                    {{ item.attributes.horario_termino | removerSegundos }}
                  </p>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <p>
                    <strong>Observações:</strong><br />
                    {{ item.attributes.justificativa }}
                  </p>
                  <p v-if="item.attributes.motivo">
                    <strong>Motivo do Indeferimento:</strong><br />
                    {{ item.attributes.motivo }}
                  </p>

                  <p class="hidden-xs-only">
                    <strong>Status:</strong><br />
                    <span :class="item.attributes.status.toLowerCase()">{{
                      item.attributes.status
                    }}</span>
                  </p>

                  <p
                    v-if="
                      carregando !== true &&
                      selected !== 'Historico' &&
                      selected !== 'Indeferida'
                    ">
                    <strong>Ação:</strong><br />
                    <v-btn
                      v-if="isAdministrador && selected === 'Pendente'"
                      class="ml-2 mt-1 green--text"
                      small
                      elevation="3"
                      @click="confirmarReserva"
                      ><v-icon>mdi-check-circle-outline</v-icon>
                      Aceitar
                    </v-btn>
                    <v-btn
                      v-if="selected === 'Pendente'"
                      class="ml-2 mt-1 red--text"
                      small
                      elevation="3"
                      @click="
                        {
                          {
                            isDono
                              ? selectCancelDialog(item)
                              : selectIndefDialog(item)
                          }
                        }
                      ">
                      <v-icon>mdi-close-circle-outline</v-icon>
                      {{ isDono ? "Cancelar" : "Indeferir" }}
                    </v-btn>
                    <v-btn
                      v-if="selected === 'Confirmado'"
                      class="ml-2 mt-1 red--text"
                      small
                      elevation="3"
                      @click="selectCancelDialog(item)">
                      <v-icon>mdi-close-circle-outline</v-icon> Cancelar
                    </v-btn>
                    <router-link
                      :to="{
                        name:
                          selected === 'Confirmado'
                            ? 'cancelarDiasReserva'
                            : 'editarReserva',
                        params: { id: item.id },
                      }"
                      v-if="
                        selected === 'Confirmado' || selected === 'Pendente'
                      "
                      v-slot="{ navigate }">
                      <v-btn
                        @click="navigate"
                        small
                        class="ml-2 mt-1 blue--text"
                        elevation="3"
                        ><v-icon>mdi-calendar</v-icon>
                        Alterar
                      </v-btn></router-link
                    >
                  </p>
                </v-col>
              </v-row>
            </td>
          </template>
          <template v-slot:no-data>
            <div class="d-flex flex-column align-center">
              <h3>{{ statusMessage }}</h3>
              <v-img
                max-width="425px"
                src="../../assets/Ilustracao-login.png"></v-img>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-reserva-dialog
      tipo="confirma"
      :visivel="dialogCancel"
      :mensagem="confirmationDialog.title"
      :corpoMensagem="confirmationDialog.message"
      @close="dialogCancel = false">
      <div class="cancelar">
        <v-btn
          v-if="selected === 'Pendente' || 'Confirmado'"
          @click="cancelarReserva"
          class="pa-4"
          min-width="100"
          min-height="50"
          color="primary"
          outlined>
          Sim
        </v-btn>
        <v-btn
          @click="dialogCancel = false"
          class="pa-4 ml-6"
          min-width="100"
          min-height="50"
          color="primary">
          Não
        </v-btn>
      </div>
    </v-reserva-dialog>
    <v-dialog-indeferir-reserva
      tipo="confirma"
      :visivel="dialogIndef"
      :mensagem="confirmationDialog.title"
      :corpoMensagem="confirmationDialog.message"
      @confirma="indeferirReserva"
      @close="dialogIndef = false">
    </v-dialog-indeferir-reserva>
  </v-container-principal>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import VContainerPrincipal from "../../components/VContainerPrincipal"
import VReservaDialog from "@/components/base/VDialogReservaqui"
import VDialogIndeferirReserva from "../../components/dialogs/VDialogIndeferirReserva.vue"
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import VCabecalho from "@/components/VCabecalho"
import dayjs from "dayjs"
import VCabecalhoBtn from "../../components/VCabecalhoBtn"
import customParseFormat from "dayjs/plugin/customParseFormat"
dayjs.extend(customParseFormat)

const reservaRepository = RepositoryFactory.get("reserva")
const COPIAR_EMAIL_MSG = "Copiar e-mail"
const EMAIL_COPIADO_MSG = "E-mail copiado para área de transferência!"
const COPIAR_EMAIL_ERROR_MSG = "Erro ao copiar o e-mail!"
const PENDENTE = "Pendente"
const PENDENTES = "pendentes"
const CONFIRMADO = "Confirmado"
const CONFIRMADAS = "confirmadas"
const INDEFERIDA = "Indeferida"
const INDEFERIR_RESERVA = "Indeferir reserva"
const INDEFERIR_RESERVA_MESSAGE =
  "Tem certeza que deseja indeferir esta reserva?"
const CANCELADA = "Cancelada"
const CANCELAR_RESERVA = "Cancelar reserva"
const CANCELAR_RESERVA_MESSAGE = "Tem certeza que deseja cancelar esta reserva?"
const HISTORICO = "Historico"
const NO_HISTORICO = "no histórico"
const SORT_PADRAO = "attributes.publishedAt"
const DESCENDENTE = "desc"
const ASCENDENTE = "asc"
const NAO_HA_RESERVAS = "Não há reservas"
const NAO_POSSUI_RESERVAS = "Você ainda não possui reservas"
const RESERVA_CONFIRMADA_SUCESSO = "Reserva confirmada com sucesso!"
const RESERVA_INDEFERIDA_SUCESSO = "Reserva indeferida com sucesso!"
const RESERVA_CANCELADA_SUCESSO = "Reserva cancelada com sucesso!"

export default {
  components: {
    VContainerPrincipal,
    VCabecalho,
    VReservaDialog,
    VCabecalhoBtn,
    VDialogIndeferirReserva,
  },

  data: () => ({
    headers: [
      {
        text: "STATUS",
        value: "attributes.status",
        sortable: true,
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "SOLICITAÇÃO",
        value: "attributes.publishedAt",
        sortable: true,
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "NOME",
        value: "attributes.titulo",
        sortable: true,
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "RESPONSÁVEL",
        value: "attributes.responsavel.data.attributes.username",
        sortable: true,
        width: "15%",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "SALA",
        value: "attributes.sala.data.attributes.nome",
        sortable: true,
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "BLOCO/PISO",
        value: "attributes.sala.data.attributes.bloco.descricao",
        sortable: true,
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "DATA/HORARIO/FREQUÊNCIA",
        value: "attributes.data_inicio",
        sortable: true,
        width: "30%",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "",
        value: "data-table-expand",
      },
    ],

    options: {
      sortBy: [SORT_PADRAO],
      sortDesc: [true],
    },

    footerProps: {
      itemsPerPageText: "Itens por página",
      itemsPerPageOptions: [10, 30, 50, 70, 100],

      pagination: {
        page: 1,
        itemsPerPage:
          Number(localStorage.getItem("reservas.itemsPerPage")) || 10,
        pageStart: 0,
        pageStop: 0,
        itemsLength: 0,
      },
    },

    expanded: [],
    reservas: [],
    carregando: true,
    tab: null,
    selected: PENDENTE,
    reservaSelecionada: null,

    confirmationDialog: {
      title: "",
      message: "",
      motivo: "",
    },

    filtros: {
      estado: "",
      titulo: "",
      responsavel: "",
    },

    filtroSolicitacao: "",
    filtroInicio: "",

    diaSolicitacao: "",
    diaInicio: "",

    textoPesquisa: "",
    delayPesquisa: null,

    selecao: {
      status: "",
    },

    dialogIndef: false,
    dialogCancel: false,

    msgTooltip: COPIAR_EMAIL_MSG,

    data: new Date(),
    estados: [CANCELADA, CONFIRMADO, INDEFERIDA, PENDENTE],
  }),

  mounted() {
    if (!this.isAdministrador) {
      this.filtros.responsavel = this.getPrimeiroEultimo(this.nome)
    }
    this.selected = this.$route.query.status || PENDENTE
    this.changeTab(this.selected)
    this.getReservas(this.selected)
  },

  computed: {
    isDono() {
      if (this.expanded.length == 0) {
        return false
      }
      const reserva = this.expanded[0]
      return this.userId === reserva.attributes.responsavel.data.id
    },
    reservasComputadas() {
      return this.reservas.filter((r) =>
        r.attributes.titulo
          .toLowerCase()
          .includes(this.textoPesquisa.toLowerCase())
      )
    },
    statusMessage() {
      let customMessage = ""
      switch (this.selected) {
        case PENDENTE:
          customMessage = PENDENTES
          break
        case CONFIRMADO:
          customMessage = CONFIRMADAS
          break
        case HISTORICO:
          customMessage = NO_HISTORICO
          break
      }
      if (this.isAdministrador) {
        return `${NAO_HA_RESERVAS} ${customMessage}`
      } else {
        return `${NAO_POSSUI_RESERVAS} ${customMessage}`
      }
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      nome: ["auth/username"],
      userId: ["auth/userId"],
    }),
  },

  filters: {
    formatarData(data) {
      return dayjs(data).format("DD/MM/YYYY")
    },
    formatarHora(data) {
      return dayjs(data).format("HH:mm:ss")
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      nome: ["auth/username"],
    }),

    removerSegundos(horario) {
      return horario.slice(0, horario.lastIndexOf(":"))
    },
    formatarNome(nome) {
      return `${nome.slice(0, nome.indexOf(" "))} ${nome.slice(
        nome.lastIndexOf(" ")
      )}`
    },
    lowercase: function (value) {
      if (!value) return ""
      return value.toString().toLowerCase()
    },
  },

  watch: {
    selected: function () {
      this.$router.replace({ query: { status: this.selected } })
    },

    filtros: {
      handler() {
        this.debounce()
      },
      deep: true,
    },

    filtroSolicitacao: {
      handler() {
        if (dayjs(this.filtroSolicitacao, "DD/MM/YYYY").isValid()) {
          this.diaSolicitacao = dayjs(
            this.filtroSolicitacao,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")
          this.debounce()
        }
        if (this.filtroSolicitacao == "" || this.filtroSolicitacao == null) {
          this.diaSolicitacao = ""
          this.debounce()
        }
      },
    },

    filtroInicio: {
      handler() {
        if (dayjs(this.filtroInicio, "DD/MM/YYYY").isValid()) {
          this.diaInicio = dayjs(this.filtroInicio, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          )
          this.debounce()
        }
        if (this.filtroInicio == "" || this.filtroInicio == null) {
          this.diaInicio = ""
          this.debounce()
        }
      },
    },
  },

  methods: {
    debounce() {
      if (this.delayPesquisa) {
        clearTimeout(this.delayPesquisa)
        this.delayPesquisa = null
      }
      this.delayPesquisa = setTimeout(() => {
        this.getReservas(this.selected)
      }, 500)
    },
    getPrimeiroEultimo(nome) {
      return this.$options.filters.formatarNome(nome)
    },
    changeTab(tab) {
      switch (tab) {
        case PENDENTE:
          this.tab = 0
          break
        case CONFIRMADO:
          this.tab = 1
          break
        case INDEFERIDA:
          this.tab = 2
          break
        case HISTORICO:
          this.tab = 3
          break
        default:
          break
      }
    },
    getReservas(status) {
      this.carregando = true
      this.selected = status
      let filtros = {
        titulo: this.filtros.titulo,
        estado: this.filtros.estado,
        dataSolicitacao: this.diaSolicitacao,
        dataInicio: this.diaInicio,
      }
      if (this.isAdministrador) {
        filtros.responsavel = this.filtros.responsavel
        filtros.userId = this.userId
      }
      reservaRepository
        .get(
          this.selected,
          this.footerProps.pagination.page,
          this.footerProps.pagination.itemsPerPage,
          {
            field: this.getFieldName(),
            order: this.getSortOrder(),
          },
          filtros
        )
        .then((res) => {
          this.reservas = res.data.data.map((r) =>
            Object.assign(r, {
              showTooltip: false,
              showTooltipExpandido: false,
            })
          )
          this.updateFooterProps(
            res.data.meta.pagination.total,
            res.data.data.length
          )
          this.carregando = false
        })
    },
    selectCancelDialog(item) {
      this.reservaSelecionada = item
      this.confirmationDialog.title = CANCELAR_RESERVA
      this.confirmationDialog.message = CANCELAR_RESERVA_MESSAGE
      this.dialogCancel = true
    },
    selectIndefDialog(item) {
      this.reservaSelecionada = item
      this.confirmationDialog.title = INDEFERIR_RESERVA
      this.confirmationDialog.message = INDEFERIR_RESERVA_MESSAGE
      this.dialogIndef = true
    },
    cancelarReserva() {
      const reserva = this.expanded[0]
      let reservaPayload = {
        data: {
          responsavel: reserva.attributes.responsavel.data.id,
          status: CANCELADA,
        },
      }
      reservaRepository
        .update(reserva.id, reservaPayload)
        .then((res) => {
          if (res.status === 200) this.showSucesso(RESERVA_CANCELADA_SUCESSO)
          this.removerReserva(reserva)
        })
        .catch((error) => {
          this.showErro(error.response.data.error.message)
        })
        .finally(() => {
          this.dialogCancel = false
        })
    },
    indeferirReserva({ motivo }) {
      const reserva = this.expanded[0]
      let reservaPayload = {
        data: {
          responsavel: reserva.attributes.responsavel.data.id,
          motivo: motivo,
          status: INDEFERIDA,
        },
      }
      reservaRepository
        .update(reserva.id, reservaPayload)
        .then((res) => {
          if (res.status === 200) this.showSucesso(RESERVA_INDEFERIDA_SUCESSO)
          this.removerReserva(reserva)
        })
        .catch((error) => {
          this.showErro(error.response.data.error.message)
        })
        .finally(() => {
          this.dialogIndef = false
        })
    },
    confirmarReserva() {
      const reserva = this.expanded[0]
      let reservaPayload = {
        data: {
          responsavel: reserva.attributes.responsavel.data.id,
          titulo: reserva.attributes.titulo,
          justificativa: reserva.attributes.justificativa,
          motivo: this.confirmationDialog.motivo,
          status: CONFIRMADO,
          participantes: reserva.attributes.participantes,
          computadores: reserva.attributes.computadores,
          arcondicionado: reserva.attributes.arcondicionado,
          projetor: reserva.attributes.projetor,
          mesa: reserva.attributes.mesa,
          lousa: reserva.attributes.lousa,
          sala: reserva.attributes.sala.data.id,
          data_inicio: reserva.attributes.data_inicio,
          data_termino: reserva.attributes.data_termino,
          horario_inicio: reserva.attributes.horario_inicio,
          horario_termino: reserva.attributes.horario_termino,
          dias: reserva.attributes.dias,
        },
      }
      reservaRepository
        .update(reserva.id, reservaPayload)
        .then((res) => {
          if (res.status === 200) this.showSucesso(RESERVA_CONFIRMADA_SUCESSO)
          this.removerReserva(reserva)
        })
        .catch((error) => {
          this.showErro(error.response.data.error.message)
        })
    },
    removerReserva(reserva) {
      this.reservas.splice(
        this.reservas.findIndex((item) => item.id === reserva.id),
        1
      )
      this.expanded.splice(0)
    },
    updateFooterProps(total, reservasSize) {
      this.footerProps.pagination.itemsLength = total
      this.footerProps.pagination.pageStart =
        (this.footerProps.pagination.page - 1) *
        this.footerProps.pagination.itemsPerPage
      this.footerProps.pagination.pageStop =
        this.footerProps.pagination.pageStart + reservasSize
    },
    updatePage(page) {
      this.footerProps.pagination.page = page
      this.getReservas(this.selected)
    },
    updateItemsPerPage(itemsPerPage) {
      localStorage.setItem("reservas.itemsPerPage", itemsPerPage)
      this.footerProps.pagination.itemsPerPage = itemsPerPage

      reservaRepository
        .get(
          this.selected,
          this.footerProps.pagination.page,
          this.footerProps.pagination.itemsPerPage
        )
        .then((res) => {
          this.reservas = res.data.data
          this.updateFooterProps(
            res.data.meta.pagination.total,
            res.data.data.length
          )
        })
    },
    copiaEmail(email, id, expandido) {
      this.msgTooltip = EMAIL_COPIADO_MSG
      const reserva = this.reservas.find((reserva) => reserva.id == id)

      navigator.clipboard
        .writeText(email)
        .then(() => {
          if (expandido) {
            reserva.showTooltipExpandido = true

            setTimeout(() => {
              reserva.showTooltipExpandido = false

              this.msgTooltip = COPIAR_EMAIL_MSG
            }, 1500)
          } else {
            reserva.showTooltip = true

            setTimeout(() => {
              reserva.showTooltip = false

              this.msgTooltip = COPIAR_EMAIL_MSG
            }, 1500)
          }
        })
        .catch(() => {
          this.showError(COPIAR_EMAIL_ERROR_MSG)
        })
    },
    getFieldName() {
      const sort =
        this.options.sortBy.length > 0 ? this.options.sortBy[0] : SORT_PADRAO
      return sort.replaceAll("attributes.", "").replaceAll("data.", "")
    },
    getSortOrder() {
      return this.options.sortDesc[0] ? DESCENDENTE : ASCENDENTE
    },
    updateSortDesc() {
      this.getReservas(this.selected)
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>

<style scoped>
.pendente {
  color: #fa9800;
}

.confirmado {
  color: green;
}

.indeferida,
.cancelada {
  color: red;
}

.pendente,
.confirmado,
.indeferida,
.cancelada {
  font-weight: bolder;
}

.motivo {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.v-input {
  width: 80%;
  font-weight: normal;
  font-size: small;
}

.v-text-field {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
